import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

import type { CarrierMemberStats } from "types/company/carrier";

interface Props {
  companyId: number;
}

/**
 * The carrier company's active members with their quote, booking and
 * satisfaction figures. Shippers get one route (with partner state), a carrier
 * gets another for its own company only; anyone else gets no request at all.
 */
export function useCarrierMemberStats(props: Props) {
  const { companyId } = props;
  const { role, company } = useRoleContext();

  const isShipper = role?.type === "SHIPPER";
  const isOwnCarrierCompany =
    role?.type === "CARRIER" && company?.id === companyId;

  let url: string | null = null;
  if (isShipper) {
    url = `/companies/${companyId}/carrier-profile/member-stats`;
  } else if (isOwnCarrierCompany) {
    url = `/companies/${companyId}/carrier-member-stats`;
  }

  const { data, loading, error } = useSwrFetch<CarrierMemberStats[]>({
    url,
    errorMessage: "Failed to fetch team members",
  });

  return { members: data ?? null, loading, error, isShipper };
}
